import { Text, HStack, Icon } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { handleResponseLanguage } from '../../../../../../i18n';
import { Warning } from '../../../../../../types/Quotes';
import GrayTextBox from '../../../../../company-scan/components/GrayTextBox';

interface Props {
  benefits: Warning[];
  withTitle?: boolean;
}

const OfferBenefit: React.FC<Props> = ({ benefits, withTitle = true }) => {
  const { t } = useTranslation();

  return (
    <GrayTextBox title={withTitle ? t('BENEFITS') : undefined}>
      {benefits.map((benefit, index) => (
        <HStack key={index} color="gray.700">
          <Icon name="GeneralActionsAdd" boxSize={4} />
          <Text
            textStyle="smallBody"
            dangerouslySetInnerHTML={{
              __html: handleResponseLanguage(benefit.description),
            }}
          />
        </HStack>
      ))}
    </GrayTextBox>
  );
};

export default OfferBenefit;
